import React from 'react'

const CompletedIcon = () => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1199_20752"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="13"
        height="13"
      >
        <rect width="13" height="13" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_1199_20752)">
        <path
          d="M5.74427 7.4776L4.56615 6.29948C4.46684 6.20017 4.34497 6.15052 4.20052 6.15052C4.05608 6.15052 3.92969 6.20469 3.82135 6.31302C3.72205 6.41233 3.6724 6.53872 3.6724 6.69219C3.6724 6.84566 3.72205 6.97205 3.82135 7.07135L5.3651 8.6151C5.46441 8.71441 5.5908 8.76406 5.74427 8.76406C5.89774 8.76406 6.02413 8.71441 6.12344 8.6151L9.1974 5.54115C9.2967 5.44184 9.34635 5.31997 9.34635 5.17552C9.34635 5.03108 9.29219 4.90469 9.18386 4.79635C9.08455 4.69705 8.95816 4.6474 8.80469 4.6474C8.65122 4.6474 8.52483 4.69705 8.42552 4.79635L5.74427 7.4776ZM6.5026 11.9193C5.7533 11.9193 5.04913 11.777 4.3901 11.4924C3.73108 11.2082 3.15781 10.8224 2.67031 10.3349C2.18281 9.8474 1.79697 9.27413 1.51277 8.6151C1.22822 7.95608 1.08594 7.25191 1.08594 6.5026C1.08594 5.7533 1.22822 5.04913 1.51277 4.3901C1.79697 3.73108 2.18281 3.15781 2.67031 2.67031C3.15781 2.18281 3.73108 1.79678 4.3901 1.51223C5.04913 1.22803 5.7533 1.08594 6.5026 1.08594C7.25191 1.08594 7.95608 1.22803 8.6151 1.51223C9.27413 1.79678 9.8474 2.18281 10.3349 2.67031C10.8224 3.15781 11.2082 3.73108 11.4924 4.3901C11.777 5.04913 11.9193 5.7533 11.9193 6.5026C11.9193 7.25191 11.777 7.95608 11.4924 8.6151C11.2082 9.27413 10.8224 9.8474 10.3349 10.3349C9.8474 10.8224 9.27413 11.2082 8.6151 11.4924C7.95608 11.777 7.25191 11.9193 6.5026 11.9193Z"
          fill="#5DB594"
        />
      </g>
    </svg>
  )
}

export default CompletedIcon
